import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { useScrollReveal } from './useScrollReveal';
export function GuaranteeSection() {
  const ref = useScrollReveal();
  return <section className="w-full bg-salvia-light py-12 px-5 flex justify-center" data-id="element-63">
      <div ref={ref} className="fade-up w-full max-w-md flex flex-col items-center text-center gap-4" data-id="element-64">
        <div className="bg-white p-4 rounded-full shadow-sm mb-2" data-id="element-65">
          <ShieldCheck className="w-10 h-10 text-salvia" data-id="element-66" />
        </div>
        <h2 className="font-serif font-bold text-petroleo text-2xl leading-tight" data-id="element-67">
          Garantía de 7 días. Sin preguntas.
        </h2>
        <p className="text-gray-700 text-base leading-relaxed" data-id="element-68">
          Si en 7 días no sentís ningún cambio y no quedás conforme, te
          devolvemos el 100% de tu dinero. Sin formularios, sin excusas.
          Escribinos por WhatsApp y listo.
        </p>
      </div>
    </section>;
}